module.exports = __webpack_public_path__ + "img/vote-1@2x.8f20a818.png";